module.exports = __webpack_public_path__ + "static/media/Asset 4.0cad5dd7.png";